// Uso e créditos (/api/client/usage + /api/client/me).
import { useEffect, useState } from 'react';
import { api, brl, int, ms, when, type Usage as UsageData } from '../api';
import { useMeRequired } from '../me';

const KIND: Record<string, string> = { topup: 'recarga', charge: 'consumo', adjust: 'ajuste' };

export function Usage() {
  const { me, refresh } = useMeRequired();
  const [u, setU] = useState<UsageData | null>(null);
  useEffect(() => { void refresh(); api<UsageData>('/api/client/usage').then(setU).catch(() => setU({ jobs: [], transactions: [] })); }, [refresh]);
  const p = me.pricing;

  return (
    <>
      <div className="ph"><div><p className="eyebrow">Consumo</p><h1>Uso e créditos</h1><p>Cada tarefa desconta do saldo pelos tokens de entrada e saída, na tarifa do modelo.</p></div></div>
      <div className="grid g4">
        <div className="card stat"><span className="lbl">{me.creditsScope === 'org' ? 'Saldo da empresa' : 'Saldo'}</span><span className={`val ${me.credits > 0 ? 'ok' : 'err'}`}>{brl(me.credits, 2)}</span><span className="sub">{me.credits > 0 ? 'pronto para usar' : me.creditsScope === 'org' ? 'peça uma recarga ao administrador' : 'peça uma recarga'}</span></div>
        <div className="card stat"><span className="lbl">Tarefas</span><span className="val">{me.usage.jobs}</span></div>
        <div className="card stat"><span className="lbl">Tokens</span><span className="val">{int(me.usage.output_tokens)}</span><span className="sub">{int(me.usage.input_tokens)} de entrada</span></div>
        <div className="card stat"><span className="lbl">Total gasto</span><span className="val">{brl(me.usage.charge, 2)}</span></div>
      </div>
      {u && (
        <>
          <section className="sec">
            <div className="sec-h"><h2>Tarefas</h2></div>
            {u.jobs.length === 0 ? <div className="empty">Nenhuma tarefa ainda.</div> : (
              <div className="tbl"><table>
                <thead><tr><th>quando</th><th>origem</th><th>modelo</th><th>status</th><th className="r">in / out</th><th className="r">tempo</th><th className="r">custo</th><th>pedido</th></tr></thead>
                <tbody>{u.jobs.map((j) => (
                  <tr key={j.id}>
                    <td className="mono">{when(j.created_at)}</td>
                    <td>{j.source === 'api' ? 'API' : j.source === 'image' ? 'imagem' : 'conversa'}</td>
                    <td>{j.model ?? ''}</td>
                    <td><span className={j.status === 'done' ? 'ok' : j.status === 'error' ? 'err' : 'mute'}>{j.status}</span></td>
                    <td className="mono r">{j.input_tokens ?? '–'} / {j.output_tokens ?? '–'}</td>
                    <td className="mono r">{ms(j.duration_ms)}</td>
                    <td className="mono r">{brl(j.charge)}</td>
                    <td className="ell">{j.prompt_preview}</td>
                  </tr>
                ))}</tbody>
              </table></div>
            )}
          </section>
          <div className="grid g2 sec">
            <section>
              <div className="sec-h"><h2>Créditos</h2></div>
              {u.transactions.length === 0 ? <div className="empty">Sem movimentações.</div> : (
                <div className="tbl"><table>
                  <thead><tr><th>quando</th><th>tipo</th><th className="r">valor</th><th className="r">saldo após</th><th>detalhe</th></tr></thead>
                  <tbody>{u.transactions.map((t) => (
                    <tr key={t.id}><td className="mono">{when(t.created_at)}</td><td>{KIND[t.kind] ?? t.kind}</td><td className={`mono r ${t.amount >= 0 ? 'ok' : ''}`}>{brl(t.amount)}</td><td className="mono r">{brl(t.balance_after)}</td><td>{t.note ?? ''}</td></tr>
                  ))}</tbody>
                </table></div>
              )}
            </section>
            <section>
              <div className="sec-h"><h2>Tarifas</h2><span className="n">R$ por 1M tokens</span></div>
              <div className="tbl"><table>
                <thead><tr><th>modelo</th><th className="r">entrada</th><th className="r">saída</th></tr></thead>
                <tbody>
                  <tr><td><i>padrão</i></td><td className="mono r">{brl(p.defaults.chargeIn)}</td><td className="mono r">{brl(p.defaults.chargeOut)}</td></tr>
                  {Object.entries(p.models).map(([m, v]) => <tr key={m}><td>{m}</td><td className="mono r">{brl(v.chargeIn)}</td><td className="mono r">{brl(v.chargeOut)}</td></tr>)}
                </tbody>
              </table></div>
            </section>
          </div>
        </>
      )}
    </>
  );
}
